import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Loader from "../Loader/Loader";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, adminLogout } = useAuth();

  if (loading) return <Loader />;

  return adminLogout && !isAuthenticated ? <Navigate to="/admin-login" replace /> : isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
